import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';


export const ProgressIcon = (props) => (<CircularProgress color="inherit" size={18} thickness={7} {...props} />);
